module.exports = __webpack_public_path__ + "img/money-group.8aebd090.png";